import gql from 'graphql-tag';
import FieldsCreditBundle from 'graphql/fields/FieldsCreditBundle';
import FieldsCreditQrCode from 'graphql/fields/FieldsCreditQrCode';

export default gql(`
	query credit_qr_codes( $status: [String] ) {
		credit_qr_codes( status: $status ) {
			${FieldsCreditQrCode}

			timeslot_kind {
				guid
			}
		}
	}
`);

